<template>
  <div class="container-fluid py-4">
    <h1 class="page-heading">Клиенты Vendoscope API</h1>
    <p class="text-muted">Служебная страница управления доступом внешних систем. Она не публикуется в меню.</p>

    <ul class="nav nav-tabs mt-4" role="tablist">
      <li class="nav-item">
        <button class="nav-link" :class="{active: activeTab === 'keys'}" type="button" @click="activeTab = 'keys'">API-ключи</button>
      </li>
      <li class="nav-item">
        <button class="nav-link" :class="{active: activeTab === 'swagger'}" type="button" @click="showSwagger">Swagger JSON</button>
      </li>
    </ul>

    <section v-if="activeTab === 'keys'" class="pt-4" aria-label="API-ключи">
      <form class="card card-body mb-4" @submit.prevent="createClient">
        <div class="form-row align-items-end">
          <div class="form-group col-md-5">
            <label for="api-client-name">Название клиента</label>
            <input id="api-client-name" v-model="newClient.name" class="form-control" maxlength="190" required>
          </div>
          <div class="form-group col-md-5">
            <label for="api-client-expires">Действует до</label>
            <input id="api-client-expires" v-model="newClient.expires_at" type="datetime-local" class="form-control">
          </div>
          <div class="form-group col-md-2">
            <button class="btn btn-primary btn-block" type="submit">Создать</button>
          </div>
        </div>
      </form>

      <div v-if="plainTextToken" class="alert alert-warning" role="alert">
        <strong>Сохраните токен сейчас:</strong>
        <code class="d-block mt-2 text-break">{{ plainTextToken }}</code>
        После обновления страницы токен больше не будет показан.
      </div>

      <div class="table-responsive">
        <table class="table table-striped">
          <thead><tr><th>Клиент</th><th>Префикс</th><th>Истекает</th><th>Статус</th><th></th></tr></thead>
          <tbody>
            <tr v-for="client in clients" :key="client.id">
              <td>{{ client.name }}</td>
              <td><code>{{ client.token_prefix }}</code></td>
              <td>{{ client.expires_at || 'Без ограничения' }}</td>
              <td>{{ client.revoked_at ? 'Отозван' : 'Активен' }}</td>
              <td class="text-right"><button v-if="!client.revoked_at" class="btn btn-outline-danger btn-sm" @click="revoke(client)">Отозвать</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section v-else class="pt-4" aria-label="Swagger JSON">
      <div class="d-flex align-items-center mb-3">
        <p class="mb-0 mr-auto text-muted">OpenAPI 3.0 контракт внешнего Vendoscope API.</p>
        <button class="btn btn-outline-primary btn-sm" type="button" @click="copySwagger">Копировать JSON</button>
      </div>
      <pre class="card card-body overflow-auto"><code>{{ swaggerJson }}</code></pre>
    </section>
  </div>
</template>

<script>
import api from '@/api'

export default {
  metaInfo: {title: 'Клиенты Vendoscope API'},
  data: () => ({
    clients: [],
    activeTab: 'keys',
    swagger: null,
    plainTextToken: null,
    newClient: {name: '', expires_at: null, abilities: []},
  }),
  created () {
    this.load()
  },
  methods: {
    load () {
      return api.get('billing/api-clients').then(({data}) => { this.clients = data })
    },
    createClient () {
      return api.post('billing/api-clients', this.newClient).then(({data}) => {
        this.plainTextToken = data.plain_text_token
        this.newClient = {name: '', expires_at: null, abilities: []}
        return this.load()
      })
    },
    revoke (client) {
      if (!window.confirm(`Отозвать доступ для «${client.name}»?`)) return
      return api.post(`billing/api-clients/${client.id}/revoke`).then(() => this.load())
    },
    showSwagger () {
      this.activeTab = 'swagger'
      if (this.swagger) return
      return api.get('billing/api-clients/openapi.json').then(({data}) => { this.swagger = data })
    },
    copySwagger () {
      return navigator.clipboard.writeText(this.swaggerJson)
    },
  },
  computed: {
    swaggerJson () {
      return this.swagger ? JSON.stringify(this.swagger, null, 2) : 'Загрузка…'
    },
  },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/api-clients.vue